export const company = {
  name: 'Brugge Retail NV',
  storeName: 'Carrefour',
  street: 'Blankenbergse Steenweg 420',
  city: '8000 Brugge',
  country: 'Belgium',
  email: 'info@bruggeretail.com',
  phone: '+32 466 91 02 03',
  phoneHref: '+32466910203',
  enterpriseNumber: '0893.621.903',
  vatNumber: 'BE0893621903',
  foundedYear: 2007,
  yearsOfService: new Date().getFullYear() - 2007,
}
